var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneMemberBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7124 14.7605C13.4995 12.2281 13.5145 9.03638 12.046 6.68378C10.4426 4.13638 7.85029 3.44708 4.13408 4.6009C4.07415 2.41314 6.14204 0.195401 8.31482 0.105492C11.1769 -0.0143853 14.054 0.000599389 16.916 0.000599389C18.0699 0.000599389 19.2686 0.000599381 20.3775 0.255339C22.4754 0.749835 23.9289 2.72782 23.9588 4.87063C23.9888 7.58286 24.0188 10.2801 23.9439 12.9923C23.8689 15.6296 21.9659 17.8774 18.8191 17.9223C17.5154 17.9523 16.1968 17.9373 14.8781 17.9073C14.6533 17.9073 14.3686 17.7425 14.2188 17.5627C13.2748 16.3789 12.1659 15.4199 10.7124 14.7605ZM17.2607 13.9364C16.7212 13.9364 16.1818 13.9364 15.6423 13.9364C14.9231 13.9514 14.4735 14.341 14.4735 14.9553C14.4735 15.5397 14.8931 15.9593 15.5824 15.9743C16.7063 16.0043 17.8301 15.9893 18.954 15.9743C19.5833 15.9593 20.0029 15.5547 20.0179 14.9853C20.0329 14.3859 19.6283 13.9663 18.939 13.9364C18.3696 13.9214 17.8151 13.9364 17.2607 13.9364Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05643 23.9321C5.18334 23.9321 3.31025 23.9321 1.43716 23.9321C0.313309 23.9321 -0.121248 23.4526 0.0285994 22.3437C0.388232 19.7664 1.67692 17.8333 4.05948 16.6645C8.10536 14.6716 13.1852 17.3388 13.8445 21.8043C13.8595 21.9242 13.9044 22.044 13.9344 22.1639C14.0992 23.2578 13.8445 23.992 12.4959 23.9621C10.6827 23.9021 8.86957 23.9321 7.05643 23.9321Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02576 9.92022C3.04074 7.80738 4.85389 6.00922 6.98172 5.99423C9.13952 5.97925 10.9976 7.83735 10.9677 9.99515C10.9377 12.138 9.07958 13.9661 6.95175 13.9211C4.79396 13.8912 2.99579 12.063 3.02576 9.92022Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneMemberBlue);
export default __webpack_public_path__ + "static/media/oneMemberBlue.f0f11bb852b4f7727d8e98a8f7926bfe.svg";
export { ForwardRef as ReactComponent };